// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"246":"component---src-pages-tsx","939":"0a89e898"}[chunkId] || chunkId) + "-" + {"246":"c1054e2f986b2bccb50c","522":"6c3d039c19d9eec6bf4b","577":"ee8b90f68ffe714acd9f","818":"2b05b5dcae2ef18cad5d","927":"38c36674a9f021cdb03d","939":"b08b3a05b3a587463b6b"}[chunkId] + ".js";
};